// ============================================================
// devices.nav.ts — Phase-3 migration descriptor
// ------------------------------------------------------------
// Component-free, data-only navigation descriptor for the
// organization Devices feature. Imports ONLY pure types/constants
// (@twist/ui-navigation types + @twist/core security primitives) — no
// component / feature code — so the registry stays a pure data graph.
//
// Security mirrors the STRICTER of the legacy chrome: the legacy sidebar
// "Devices" leaf sat under a group gated requireOrganization +
// MyOrganization__Devices_Read; the /devices route guard itself carried
// no permission. We keep the stricter NAV constraint so nav-visible ⊆
// route-accessible (we never loosen to the weaker route gate).
// ============================================================
import { OrgPermissions } from '@twist/core';
import type { NavDescriptor } from '@twist/ui-navigation';

export const devicesNav: NavDescriptor = {
  id: 'devices',
  path: '/devices',
  label: 'Devices',
  icon: 'qrCode',
  group: 'Organization',
  // Organization section = 20s; Devices second (after Products).
  order: 21,
  surfaces: ['sidebar', 'palette'],
  security: {
    requireOrganization: true,
    orgPermissions: [OrgPermissions.MyOrganization__Devices_Read],
  },
};
